import React, { Component } from 'react';
import axios from 'axios';
import { API_URL } from '../../partials/Globals';
import Errors from '../../partials/Errors';
import Message from '../../partials/Message';
import backArrow from '../../../img/icons/left-arrow-white.svg';

export default class New extends Component {
    state = {
        project: {
            title: '',
            pivot: {
                share_price: ''
            }
        },
        initErrors: '',
        pay: 'Betala 0 kr',
        customer: {
            first_name: '',
            last_name: '',
            cellphone: '',
            email: ''
        },
        shares: 1
    }

    constructor(props) {
        super(props);

        this.inputChange = this.inputChange.bind(this);
        this.add = this.add.bind(this);
        this.subtract = this.subtract.bind(this);
        this.submit = this.submit.bind(this);
    }

    componentDidMount() {
        axios.get(API_URL+'/user/projects/'+this.props.match.params.project_id)
            .then(response => {
                this.setState({ project: response.data });

                // Sätt rätt pris på knapp
                this.setState({ pay: `Betala ${ this.state.shares*response.data.pivot.share_price } kr` });
            })
            .catch(error => {
                this.setState({ initErrors: {1: 'Någonting gick fel, var god ladda om sidan för att försöka igen. Om problemet kvarstår kontrollera din internetanslutning.'} })
            });
    }

    inputChange(event) {
        this.setState({ customer: {...this.state.customer, [event.target.name]: event.target.value } });
    }

    add(event) {
        event.preventDefault();
        this.setState({ shares: this.state.shares+1 }, function() {
            this.setState({ pay: `Betala ${ this.state.shares*this.state.project.pivot.share_price } kr` });
        });
    }

    subtract(event) {
        event.preventDefault();
        if (this.state.shares > 1) {
            this.setState({ shares: this.state.shares-1  }, function() {
                this.setState({ pay: `Betala ${ this.state.shares*this.state.project.pivot.share_price } kr` });
            });
        }
    }

    submit(event) {
        event.preventDefault();

        axios.post(API_URL+'/user/transactions/'+this.props.match.params.project_id, {
            first_name: this.state.customer.first_name,
            last_name: this.state.customer.last_name,
            email: this.state.customer.email,
            cellphone: this.state.customer.cellphone,
            shares: this.state.shares
        })
        .then(response => {
            this.setState({ message: 'Ett SMS har skickats till mottagaren.' });
            this.setState({ shares: 1, customer: {
                'first_name' : '',
                'last_name': '',
                'cellphone': '',
                'email': ''
            } });
            this.setState({ pay: `Betala ${ this.state.shares*this.state.project.pivot.share_price } kr` });
        })
        .catch(error => {
            // Valideringsfel
            if (error.response && error.response.status === 422) {
                this.setState({ errors: error.response.data }); 
            } else if (error.response && error.response.status === 424) {
                this.setState({ errors: {1: 'Det gick inte att skicka SMS till mottagaren. Var god kontrollera numret och försök igen.'} })
            } else {
                this.setState({ errors: {1: 'Någonting gick fel, var god försök igen.'} })
            }
        });
    }

    render() {
        if (this.state.initErrors) {
            return <Errors errors={ this.state.initErrors } />
        }

        return (
            <div>
                <div className="transaction-header">
                    <div className="container">
                        <div className="col-12">
                            <a className="back" onClick={ this.props.history.goBack }>
                                <img src={ backArrow } alt="Tillbaka" /> 
                            </a>

                            <div className="wrapper">
                                <span>Projekt</span>
                                <h1>{ this.state.project.title }</h1>
                                <span className="byline">En andel kostar { this.state.project.pivot.share_price } kr</span>
                            </div>
                        </div> 
                    </div>  
                </div>

                <Errors errors={ this.state.errors } />
                <Message message={ this.state.message } />

                <div className="container">
                    <div className="content">
                        <form className="transaction-form" onSubmit={ this.submit }>
                            <input type="text" name="first_name" placeholder="Förnamn" required value={ this.state.customer.first_name } onChange={ this.inputChange } />
                            <input type="text" name="last_name" placeholder="Efternamn" required value={ this.state.customer.last_name } onChange={ this.inputChange } />
                            <input type="text" name="cellphone" placeholder="Mobilnummer (07XXXXXXXX)" required value={ this.state.customer.cellphone } onChange={ this.inputChange } />
                            <input type="email" name="email" placeholder="E-postadress (för gåvobevis)" required value={ this.state.customer.email } onChange={ this.inputChange } />

                            <div className="shares">
                                <div className="left">
                                    Antal andelar
                                </div>
                                <div className="right">
                                    <button onClick={ this.subtract }>-</button>
                                    <button onClick={ this.add }>+</button>
                                    <input type="number" name="shares" readOnly value={ this.state.shares } />
                                </div>
                            </div>

                            <input type="submit" className="button yellow m-top-l" value={ this.state.pay } />
                        </form>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/user/Transaction/New.js